import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminWorkspacePage from "@/components/admin/admin-workspace-page";
import { pathToAdminWorkspaceTab } from "@/lib/admin/admin-paths";

const AdminWorkspaceLayout = (): JSX.Element => {
	const { workspaceId } = Route.useParams();
	const tab = useRouterState({
		select: (state) => {
			const pathname = state.resolvedLocation?.pathname ?? state.location.pathname;
			return (
				pathToAdminWorkspaceTab(state.location.pathname, workspaceId) ?? pathToAdminWorkspaceTab(pathname, workspaceId)
			);
		},
	});
	return (
		<AdminWorkspacePage tab={tab} workspaceId={workspaceId}>
			<Outlet />
		</AdminWorkspacePage>
	);
};

export const Route = createFileRoute("/_app/admin/workspaces/$workspaceId")({
	component: AdminWorkspaceLayout,
});
